import { IMerchant } from "@interfaces";
import { AnimatePresence, LazyMotion, Variant, domAnimation, m } from "framer-motion";
import { useEffect } from "react";

export default function BenefitBoxes({
    merchant,
    currentIndex,
}: {
    merchant: IMerchant;
    currentIndex: number;
}) {
    //Consider fixing later https://github.com/framer/motion/issues/2554
    // const [isMounted, setIsMount] = useState(false);
    // const [key, setKey] = useState(0);

    const formatDescription = (description: any) => {
        return description ? description.replace(/\n/g, "<br />") : "";
    };

    useEffect(() => {
        // if (!isMounted) setIsMount(true);
        // if (isMounted) setKey(key + 1);
    }, [merchant?._id, currentIndex]);

    return (
        <LazyMotion features={domAnimation}>
            <AnimatePresence onExitComplete={() => console.log("CM")}>
                <m.div
                    key={currentIndex}
                    variants={parentAnimation}
                    initial="hidden"
                    animate="show"
                    exit="exit"
                    style={{
                        position: "absolute",
                        width: "100%",
                        boxSizing: "border-box",
                        padding: "0 16px",
                        left: 0,
                    }}
                >
                    {merchant?.memberShipTiers?.[currentIndex]?.benefits.map((bItem: any) => (
                        <m.div
                            key={bItem.benefitTitle + bItem.benefitDescription}
                            variants={childrenAnimation}
                            className="layout-detail-card"
                        >
                            <div className="topic-member-detail">{bItem.benefitTitle}</div>

                            <div className="desc-member-detail">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: formatDescription(bItem?.benefitDescription),
                                    }}
                                ></p>
                            </div>
                            <div className="img-member-detail">
                                <a href="">
                                    <img src={bItem.benefitIcon} alt="imgmemberdetail" />
                                </a>
                            </div>
                        </m.div>
                    ))}
                </m.div>
            </AnimatePresence>
        </LazyMotion>
    );
}

//#region Animations

const parentAnimation: {
    hidden: Variant;
    show: Variant;
    exit: Variant;
} = {
    hidden: {
        opacity: 0,
    },
    show: {
        opacity: 1,
        transition: {
            when: "beforeChildren",
            staggerChildren: 0.125,
        },
    },
    exit: {
        opacity: 1,
        transition: {
            when: "afterChildren",
            staggerChildren: 0.1,
        },
    },
};

const childrenAnimation: {
    hidden: Variant;
    show: Variant;
    exit: Variant;
} = {
    hidden: {
        y: 60,
        opacity: 0,
    },
    show: {
        y: 0,
        opacity: 1,
        transition: {
            type: "spring",
            damping: 20,
            stiffness: 100,
        },
    },
    exit: {
        opacity: 0,
        y: 0,
        transition: {
            type: "spring",
            damping: 20,
            stiffness: 100,
        },
    },
};

//#endregion
